// DO NOT CHANGE THE EXISTING VALUES. They are stored in `integration.connection_kind`.
export enum ConnectionKind {
  Http = "http",
}
